import { NgClass } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AbstractFormFieldComponent } from '../../abstract-form-field.component';
import { CheckboxFormField } from '../../form-field.model';

@Component({
  selector: 'iot-platform-ui-form-checkbox-field',
  imports: [
    FlexLayoutModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatTooltipModule,
    MatCheckbox,
    FormsModule,
    NgClass
  ],
  templateUrl: './form-checkbox-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../form-field/form-field.component.scss'
})
export class FormCheckboxFieldComponent extends AbstractFormFieldComponent<CheckboxFormField> {}
